(function () {
  "use strict";

  if (window.n9PackageGuideInitialized) {
    return;
  }
  window.n9PackageGuideInitialized = true;

  if (typeof window.HTMLDialogElement === "undefined") {
    return;
  }

  var activeOpener = null;
  var pendingGuideId = null;
  var programmaticClose = new WeakSet();
  var root = document.documentElement;

  root.classList.add("n9-package-guide-supported");

  function findGuide(id) {
    return Array.from(document.querySelectorAll("dialog.n9-package-guide")).find(function (dialog) {
      return dialog.id === id;
    });
  }

  function findOpener(id) {
    return Array.from(document.querySelectorAll("[data-n9-package-guide-open]")).find(function (button) {
      return button.getAttribute("data-n9-package-guide-open") === id;
    });
  }

  function cleanUpGuide(dialog) {
    dialog.classList.remove("is-open");
    root.classList.remove("n9-package-guide-open");
  }

  function openGuide(button) {
    var guide = findGuide(button.getAttribute("data-n9-package-guide-open"));
    if (!guide || guide.open) {
      return;
    }

    activeOpener = button;
    guide.showModal();
    root.classList.add("n9-package-guide-open");

    requestAnimationFrame(function () {
      guide.classList.add("is-open");
      var closeButton = guide.querySelector("[data-n9-package-guide-close]");
      if (closeButton) {
        closeButton.focus({ preventScroll: true });
      }
    });
  }

  function closeGuide(dialog, restoreFocus) {
    var opener = activeOpener;
    programmaticClose.add(dialog);
    cleanUpGuide(dialog);

    if (dialog.open) {
      dialog.close();
    }

    if (restoreFocus && opener && opener.isConnected) {
      opener.focus({ preventScroll: true });
    }

    activeOpener = null;
  }

  function findNativePackageInput(guide, optionValueId) {
    var variantSelection = guide.closest(".f8pr-variant-selection");
    if (!variantSelection) {
      return null;
    }

    return Array.from(
      variantSelection.querySelectorAll('.n9-package-picker input[type="radio"][name^="options"][data-option-value-id]')
    ).find(function (input) {
      return input.getAttribute("data-option-value-id") === optionValueId;
    }) || null;
  }

  document.addEventListener("click", function (event) {
    var openButton = event.target.closest("[data-n9-package-guide-open]");
    if (openButton) {
      event.preventDefault();
      openGuide(openButton);
      return;
    }

    var closeButton = event.target.closest("[data-n9-package-guide-close]");
    if (closeButton) {
      event.preventDefault();
      closeGuide(closeButton.closest("dialog.n9-package-guide"), true);
      return;
    }

    var selectButton = event.target.closest("[data-n9-package-select]");
    if (selectButton) {
      event.preventDefault();
      var guide = selectButton.closest("dialog.n9-package-guide");
      var nativeInput = findNativePackageInput(guide, selectButton.getAttribute("data-n9-package-select"));

      if (!nativeInput || nativeInput.classList.contains("disabled")) {
        return;
      }

      pendingGuideId = guide.id;
      closeGuide(guide, false);
      nativeInput.click();
      return;
    }

    if (event.target.matches("dialog.n9-package-guide")) {
      closeGuide(event.target, true);
    }
  });

  document.addEventListener("cancel", function (event) {
    if (!event.target.matches("dialog.n9-package-guide")) {
      return;
    }

    event.preventDefault();
    closeGuide(event.target, true);
  });

  document.addEventListener(
    "close",
    function (event) {
      if (!event.target.matches("dialog.n9-package-guide") || programmaticClose.has(event.target)) {
        if (programmaticClose.has(event.target)) {
          programmaticClose.delete(event.target);
        }
        return;
      }

      var opener = activeOpener;
      cleanUpGuide(event.target);
      activeOpener = null;
      if (opener && opener.isConnected) {
        opener.focus({ preventScroll: true });
      }
    },
    true
  );

  window.addEventListener("themeVariantUpdated", function () {
    if (!pendingGuideId) {
      return;
    }

    var guideId = pendingGuideId;
    pendingGuideId = null;
    requestAnimationFrame(function () {
      var opener = findOpener(guideId);
      if (opener) {
        opener.focus({ preventScroll: true });
      }
    });
  });
})();
